import type { DataAction } from '../../../types/dataAction.type';
import type { PageState } from '../types/ReducerTypes';

export const UPDATE_AD_LINKS = 'UPDATE_AD_LINKS' as const;
export const updateAdLinks = (adLinks: PageState) => ({
  data: { adLinks },
  type: UPDATE_AD_LINKS,
});
export type UpdateAdLinksAction = DataAction<typeof UPDATE_AD_LINKS, { adLinks: PageState }>;
